var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row px-2 pb-1" }, [
    _c("div", { staticClass: "col-12 bg-greige" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-lg-7 py-1" }, [
          _c("div", { staticClass: "bg-greige d-flex align-items-center" }, [
            _c("div", {
              staticClass: "alert-icon text-primary font-size-28 me-1",
              class: ["icon", _vm.dto.icon],
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "ob1-alert-title fw-bold" }, [
                _vm._v(_vm._s(_vm.dto.title)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ob1-alert-title" }, [
                _vm._v(_vm._s(_vm.dto.text)),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm.dto.promoteLink
          ? _c(
              "div",
              {
                staticClass:
                  "col-12 col-lg-5 d-flex align-items-center justify-content-lg-end text-lg-end ps-4 ps-lg-0",
              },
              [
                !_vm.dto.remiseInternetPopinComponent
                  ? _c("a", {
                      staticClass: "ob1-link-arrow",
                      attrs: {
                        href: _vm.dto.promoteLink.url,
                        "data-oevent-category":
                          _vm.dto.promoteLink.tms.category,
                        "data-oevent-action": _vm.dto.promoteLink.tms.action,
                        "data-oevent-label": _vm.dto.promoteLink.tms.label,
                      },
                      domProps: {
                        textContent: _vm._s(_vm.dto.promoteLink.label),
                      },
                    })
                  : _c("button", {
                      staticClass: "ob1-link-arrow",
                      attrs: {
                        type: "button",
                        "data-bs-toggle": "modal",
                        "data-bs-target": _vm.dto.promoteLink.url,
                        "data-oevent-category":
                          _vm.dto.promoteLink.tms.category,
                        "data-oevent-action": _vm.dto.promoteLink.tms.action,
                        "data-oevent-label": _vm.dto.promoteLink.tms.label,
                      },
                      domProps: {
                        textContent: _vm._s(_vm.dto.promoteLink.label),
                      },
                    }),
              ]
            )
          : _vm._e(),
      ]),
    ]),
    _vm._v(" "),
    _vm.dto.remiseInternetPopinComponent
      ? _c(
          "div",
          [
            _vm.dto.remiseInternetPopinComponent
              ? _c("InternetDiscountPopinShared", {
                  ref: "remiseInternetPopin",
                  attrs: {
                    id: "remise-open-modal",
                    dto: _vm.dto.remiseInternetPopinComponent,
                    mode: "cart",
                  },
                  on: {
                    "sponsor-success": function ($event) {
                      return _vm.$emit("sponsor-success", $event)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }